import FormDynamic from './form-dynamic'
import FormField from './form-field'
import FormSubmit from './form-submit'

const dynamics = document.querySelectorAll('.js-form-dynamic')

for (let i = 0; i < dynamics.length; i++) {
  // eslint-disable-next-line no-new
  new FormDynamic(dynamics[i])
}

const fields = document.querySelectorAll('.js-form-field')

for (let i = 0; i < fields.length; i++) {
  // eslint-disable-next-line no-new
  new FormField(fields[i])
}

const forms = document.querySelectorAll('.js-form')

for (let i = 0; i < forms.length; i++) {
  // eslint-disable-next-line no-new
  new FormSubmit(forms[i])
}
